module.exports = __webpack_public_path__ + "static/smoke-3-107759ce2ba1217ac18a44dd30a59bf6.mp4";